import { Pipe, PipeTransform } from '@angular/core';
import { ProjectStatusMap } from '../constants';
import { StatusOption } from '../interfaces';

@Pipe({
  name: 'projectStatusOption',
})
export class ProjectStatusOptionPipe implements PipeTransform {
  transform(status?: string): StatusOption {
    return ProjectStatusMap.get(status);
  }
}
